import { useRef, useState } from "react";
import { useClickAway } from "react-use";
import { SearchIcon } from "../../../../icons";
import { useNavbar } from "../../hooks";
import { NavbarSearchTabletModal } from "./navbar-search-tablet-modal.component";
import styles from "./navbar-search-tablet.module.css";

export function NavbarSearchTablet() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const domRef = useRef<HTMLDivElement>(null);
  const { searchRightSlot } = useNavbar();

  const hasRightSlot = Boolean(searchRightSlot);

  useClickAway(domRef, () => {
    setIsOpen(false);
  });

  function handleClick() {
    setIsOpen(true);
  }

  function handleClose() {
    setIsOpen(false);
  }

  return (
    <>
      <div ref={domRef} className={styles.Container}>
        <button type="button" onClick={handleClick} className={styles.Button}>
          <SearchIcon viewBox="0 0 24 24" size={24} />
        </button>
        {hasRightSlot && (
          <div className={styles.Slot}>
            {searchRightSlot?.({
              isDesktop: false,
              isMobile: false,
              isTablet: true,
            })}
          </div>
        )}

        <NavbarSearchTabletModal isOpen={isOpen} onClose={handleClose} />
      </div>
    </>
  );
}
